import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';
import Modal from "react-native-modal";


//My Components
import SCMultimedia from './SCMultimedia';
import SCModal from './SCModal.js'

//import { TouchableOpacity } from 'react-native-gesture-handler';

const SituaInfoCard = ({ codigo, titulo, descripcion, multimedia, ejes, tags, pagimod }) => {

    console.log("----------------Situacion Info card-----------------")
    //console.log(descripcion);
    //console.log(tags);
    console.log(pagimod);

    const navigation = useNavigation();
    const tailwind = useTailwind();

    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = (number) => {
        console.log("activate view ",number)
        setModalVisible(!isModalVisible);
    };

    

    return (
        <View style ={ tailwind("my-4")}>
            <View style ={ tailwind("flex  px-12 py-1 flex-row-reverse ") }>
                <View style ={ tailwind("bg-matconblue h-6 w-6 mx-px ") }></View>
                <View style ={ tailwind("bg-matconred h-6 w-6 mx-px ") }></View>
                <View style ={ tailwind("bg-matcondarkblue h-6 w-6 mx-px ") }></View>
                <View style ={ tailwind("bg-matcongreen h-6 w-6 mx-px ") }></View>
                <View style ={ tailwind("bg-matconyellow h-6 w-6 mx-px ") }></View>
            </View>
            <View style ={  tailwind("bg-white px-12 py-1 flex-row flex-wrap justify-between") }>
                <View style ={ tailwind("p-6 flex flex-col w-full md:w-3/5 justify-center") }>
                    <View style ={ tailwind( "border-l-8 border-matconyellow text-lg text-center py-2") }>
                        <Text style ={ tailwind("text-gray-900 text-xl font-medium font-black text-matcondarkblue") }>{titulo["esp"]}</Text>
                    </View>
                    <View style ={ tailwind("mt-4 ")} >
                    {
                        descripcion["esp"].map((descparagraf) => {
                            return (
                                <View style ={ tailwind("") }>
                                {
                                    Platform.OS != 'web' ?   
                                    <Text style={ [tailwind("text-justify whitespace-normal"),{textAlign: 'justify'}] }>{descparagraf}</Text> 
                                    : 
                                    <p style={{fontSize: 18, textAlign: "justify"}} >{descparagraf}</p>
                                }
                                </View>
                            )
                        })
                    }
                    </View>
                    <Text style ={ tailwind("text-gray-600 text-xs mt-2 ") }>Ultima actualización hace 3 mins</Text>
                    <View style ={ tailwind("flex flex-row flex-wrap justify-center mt-4") }>
                        {
                            pagimod.map((singlepagimod, index) => {
                                return (
                                    //singlepagimod["nombre"]["esp"]
                                    <SCModal 
                                        nombre= {singlepagimod["nombre"]} 
                                        contenido= { singlepagimod["contenido"] }
                                    />
                                )
                            })
                        }

                    </View>
                    <View style={ tailwind("flex flex-row flex-wrap justify-center mt-2") }>
                    {
                        tags.map((tag) => {
                            return (
                                <TouchableOpacity style={ tailwind("text-xs px-3 m-2 bg-matconlightblue text-gray-800 p-4 justify-center") }><Text>#{ tag }</Text></TouchableOpacity>
                            )
                        })
                    } 
                    </View>
                </View>
                <View style={ tailwind("h-64 w-full md:w-2/5 md:h-auto bg-matconblue justify-around items-center overflow-hidden") } > 
                    <SCMultimedia 
                        tipo = { multimedia["esp"]["tipo"] }
                        multimedia = { multimedia }
                    />
                </View>
            </View>
        </View>
    );
};


export default SituaInfoCard